import type {Dispatch} from 'react'

import Select from '@/components/Select/Select'

import style from './ProductSorter.module.scss'

export enum SortBy {
  Relevance = 'Relevance',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc',
}

interface Props {
  sorter: SortBy
  setSorter: Dispatch<SortBy>
}

const OPTIONS = [
  {
    label: 'Relevance',
    value: SortBy.Relevance,
  },
  {
    label: 'Price (low to high)',
    value: SortBy.PriceAsc,
  },
  {
    label: 'Price (high to low)',
    value: SortBy.PriceDesc,
  },
]

export default memo<Props>(function ProductSorter({sorter, setSorter}) {
  return (
    <Select
      className={style.Select}
      buttonProps={{className: style.Button}}
      popoverProps={{className: style.Popover}}
      prefix={<span aria-hidden>Sort by:</span>}
      label='Sort by'
      options={OPTIONS}
      selectedItem={sorter}
      setSelectedItem={setSorter}
    />
  )
})
